import React from "react";

export interface AppContextValue {
  scrollTo: string;
  setScrollTo: React.Dispatch<React.SetStateAction<string>>;
  setStartTour: React.Dispatch<React.SetStateAction<number>>;
  cart: Record<string, number>;
  setCart: React.Dispatch<React.SetStateAction<Record<string, number>>>;
  active: number;
  setActive: React.Dispatch<React.SetStateAction<number>>;
}

const AppContext = React.createContext<AppContextValue>({} as AppContextValue);
export default AppContext;
